module.exports = __webpack_public_path__ + "img/img_pintu@2x.f6d40a1b.png";